import { Controller } from "@hotwired/stimulus"

// Tracks row checkboxes on students index. Actions dropdown becomes active (green) when rows selected.
// Select-all header checkbox syncs with row checkboxes.
export default class extends Controller {
  static targets = ["actionsButton", "actionsDropdown", "selectAll", "rowCheckbox", "deleteForm"]

  connect() {
    this.updateUI()
    this.boundValidateSubmit = this.validateSubmit.bind(this)
    if (this.hasDeleteFormTarget) {
      this.deleteFormTarget.addEventListener("submit", this.boundValidateSubmit)
    }
  }

  disconnect() {
    if (this.hasDeleteFormTarget) {
      this.deleteFormTarget.removeEventListener("submit", this.boundValidateSubmit)
    }
  }

  validateSubmit(event) {
    if (this.getSelectedIds().length === 0) {
      event.preventDefault()
    }
  }

  toggleRow(event) {
    event.stopPropagation()
    this.updateUI()
  }

  toggleSelectAll(event) {
    const checked = event.target.checked
    this.rowCheckboxTargets.forEach((cb) => { cb.checked = checked })
    this.updateUI()
  }

  updateUI() {
    const selected = this.getSelectedIds()
    const count = selected.length

    // Actions button: green when selected, grey when none
    if (this.hasActionsButtonTarget) {
      const btn = this.actionsButtonTarget
      if (count > 0) {
        btn.classList.remove("border-gray-300", "bg-white", "text-gray-500")
        btn.classList.add("border-emerald-600", "bg-emerald-600", "text-white", "hover:bg-emerald-500")
      } else {
        btn.classList.remove("border-emerald-600", "bg-emerald-600", "text-white", "hover:bg-emerald-500")
        btn.classList.add("border-gray-300", "bg-white", "text-gray-500")
        // Close dropdown when selection cleared
        if (this.hasActionsDropdownTarget && this.actionsDropdownTarget.open) {
          this.actionsDropdownTarget.removeAttribute("open")
        }
      }
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = count > 0 && count === this.rowCheckboxTargets.length
      this.selectAllTarget.indeterminate = count > 0 && count < this.rowCheckboxTargets.length
    }
    this.updateDeleteForm(selected)
  }

  getSelectedIds() {
    return this.rowCheckboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value)
      .filter(Boolean)
  }

  updateDeleteForm(ids) {
    if (!this.hasDeleteFormTarget) return
    const container = this.deleteFormTarget.querySelector("[data-student-ids]")
    if (!container) return
    container.innerHTML = ids.map((id) => `<input type="hidden" name="student_ids[]" value="${id}">`).join("")
  }

  deleteSelected(event) {
    event.preventDefault()
    if (this.getSelectedIds().length === 0) return
    this.deleteFormTarget.requestSubmit()
  }
}
